import { render } from "./ModelDiffPanel.vue?vue&type=template&id=98accaea&scoped=true"
import script from "./ModelDiffPanel.vue?vue&type=script&lang=js"
export * from "./ModelDiffPanel.vue?vue&type=script&lang=js"

import "./ModelDiffPanel.vue?vue&type=style&index=0&id=98accaea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98accaea"]])

export default __exports__